import { KeyboardEvent } from "react";
import { InnerInput, Props } from "./SearchInput.Parts";

export const SearchInput = ({
  id,
  context,
  ref,
  disabled,
  active,
  placeholder,
  searchValue,
  setSearchValue,
  onBlur,
  referenceProps,
  selection,
  setSelection,
  handleSelect,
  filteredOptions,
  activeIndex,
  setActiveIndex,
  listboxId,
}: Props) => {
  // #region Handler Functions
  const handleBackspace = (e: KeyboardEvent<HTMLInputElement>) => {
    if (searchValue === "" && selection.length > 0) {
      e.preventDefault();
      const newSelection = selection.slice(0, -1);
      setSelection(newSelection);
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    context.dataRef.current.isFocusVisible = true;

    if (typeof referenceProps.onKeyDown === "function")
      referenceProps.onKeyDown(e);

    switch (e.key) {
      case "Enter":
        if (activeIndex !== null) {
          e.preventDefault();
          handleSelect(activeIndex);
        }
        break;
      case "Backspace":
        handleBackspace(e);
        break;
    }
  };
  // #endregion

  return (
    <InnerInput
      tabIndex={-1}
      {...referenceProps}
      ref={ref}
      disabled={disabled}
      $active={active}
      placeholder={!selection.length ? placeholder : undefined}
      value={searchValue}
      onChange={(e) => {
        setSearchValue(e.target.value);
        setActiveIndex(null);
      }}
      onBlur={(e) => {
        if (typeof referenceProps.onBlur === "function")
          referenceProps.onBlur(e);

        setSearchValue("");
        onBlur?.(e);
      }}
      onClick={(e) => context.open && e.stopPropagation()}
      id={id}
      role="combobox"
      aria-expanded={context.open}
      aria-controls={listboxId}
      aria-activedescendant={
        // Tells screen readers which item is "virtually" focused
        activeIndex !== null && filteredOptions[activeIndex]
          ? `select-option-${filteredOptions[activeIndex].value}`
          : undefined
      }
      onKeyDown={handleKeyDown}
    />
  );
};
